import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import api from '@app/network/apiClient';
import { SessionAPIsI, SetUserDataThunk } from '../types';

const getLogoutThunk = (
  setUserData: SetUserDataThunk,
  sessionAPIs: SessionAPIsI
): AsyncThunk<void, void, Record<string, never>> =>
  createAsyncThunk(
    'logout',
    async (data, { dispatch }): Promise<void> => {
      localStorage.removeItem('sessionUserId');
      const response = await api.post(sessionAPIs.logout);

      await dispatch(setUserData(null));

      if (response.status >= 400) {
        throw new Error(response.data.message || 'Invalid response!');
      }
    }
  );

export default getLogoutThunk;
